import React from "react";

const STYLE_PREFIX = {
  regularRounded: "rr",
  solidRounded: "sr",
  boldRounded: "br",
  thinRounded: "tr",
  regularStraight: "rs",
  solidStraight: "ss",
  boldStraight: "bs",
  thinStraight: "ts",
};

/**
 * Flaticon UIcons wrapper.
 * Usage: <Icon name="comment" variant="regularRounded" className="text-lg" />
 */
function Icon({
  name,
  variant = "regularRounded",
  className = "",
  title,
  ariaHidden = true,
}) {
  const prefix = STYLE_PREFIX[variant] || STYLE_PREFIX.regularRounded;
  const iconClass = `fi fi-${prefix}-${name}`;

  return (
    <i
      className={`${iconClass} ${className}`.trim()}
      title={title}
      aria-hidden={ariaHidden}
      role={ariaHidden ? undefined : "img"}
    />
  );
}

export default Icon;
